<div class="section" style="width: 800px; height: 450px; flex: 1; display: flex; flex-direction: column;" data-cy="ar-ledger-payment-distributions">
  <div class="section-header" data-cy="ar-ledger-payment-distributions-header">
    <div class="section-header-title" data-cy="ar-ledger-payment-distributions-title">Ledger Payment Distributions</div>
  </div>
  <div class="section-content" style="display: flex; flex-direction: column; flex: 1;" data-cy="ar-ledger-payment-distributions-content">
    <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="ar-ledger-payment-distributions-spinner"></app-tdo-progress-spinner>
    <div *ngIf="!isLoading" style="height: 355px;" data-cy="ar-ledger-payment-distributions-table-container">
      <tdo-table [dataSource]="this.paymentDistributions"
                 [isMultiSelection]="false" [isUsePaginator]="false" [isSearchable]="false"
                 [footerData]="footerData" (rowSelected)="onRowSelected($event)"
                 data-cy="ar-ledger-payment-distributions-table">
        <tdo-table-column displayName="Amount" propertyName="PaymentAmount" isSortable="true" [rowTemplate]="paymentAmount" data-cy="ar-ledger-payment-distributions-col-amount">
          <ng-template #paymentAmount let-row>
            <div *ngIf="row.PaymentAmount" data-cy="ar-ledger-payment-distributions-amount">{{ row.PaymentAmount | currency }}</div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Distribution Date" propertyName="PaymentTransactionDate" isSortable="true" [rowTemplate]="paymentDate" data-cy="ar-ledger-payment-distributions-col-date">
          <ng-template #paymentDate let-row>
            <div *ngIf="row.PaymentTransactionDate" data-cy="ar-ledger-payment-distributions-date">{{ row.PaymentTransactionDate | date }}</div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="From" propertyName="PaymentFrom" isSortable="true" [rowTemplate]="payerName" data-cy="ar-ledger-payment-distributions-col-from">
          <ng-template #payerName let-row>
            <div *ngIf="row.PaymentFrom" data-cy="ar-ledger-payment-distributions-from">{{ row.model.PaymentFrom }}</div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Payment Type" propertyName="enumARPayementTypeID" isSortable="true" [rowTemplate]="type" data-cy="ar-ledger-payment-distributions-col-type">
          <ng-template #type let-row>
            <div *ngIf="row.enumARPayementTypeID" data-cy="ar-ledger-payment-distributions-type">{{ this.getPaymentTypeName(row) }}</div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Source" propertyName="PaymentSourceName" isSortable="true" [rowTemplate]="source" data-cy="ar-ledger-payment-distributions-col-source">
          <ng-template #source let-row>
            <div *ngIf="row.PaymentSourceName" data-cy="ar-ledger-payment-distributions-source">{{ row.model.PaymentSourceName }}</div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Distribution Type" propertyName="PaymentDistributionTypeName" isSortable="true" [rowTemplate]="dtype" data-cy="ar-ledger-payment-distributions-col-distribution-type">
          <ng-template #dtype let-row>
            <div *ngIf="row.PaymentDistributionTypeName" data-cy="ar-ledger-payment-distributions-distribution-type">{{ row.model.PaymentDistributionTypeName }}</div>
          </ng-template>
        </tdo-table-column>
        <!--        <tdo-table-column displayName="Processor" propertyName="Processor" isSortable="true" [rowTemplate]="processor">-->
        <!--          <ng-template #processor let-row>-->
        <!--            <div *ngIf="row.PaymentProcessorName">{{ row.model.PaymentProcessorName }}</div>-->
        <!--          </ng-template>-->
        <!--        </tdo-table-column>-->
        <!--        <tdo-table-column displayName="Processor" propertyName="PaymentProcessorName" isSortable="true" [rowTemplate]="processor">-->
        <!--          <ng-template #processor let-row>-->
        <!--            <div>-->
        <!--              &lt;!&ndash;            <div *ngIf="row.model.PaymentProcessorName">&ndash;&gt;-->
        <!--              <a class="link_button" (click)="ViewTransactionDetails(row.model.PaymetnID, row.model.PaymentTransactionId, row.model.enumARProcessorID)">-->
        <!--                {{ row.model.PaymentProcessorName }}-->
        <!--              </a>-->
        <!--            </div>-->
        <!--          </ng-template>-->
        <!--        </tdo-table-column>-->
      </tdo-table>
    </div>

    <div class="action-container" style="text-align: right" data-cy="ar-ledger-payment-distributions-actions">
      <button class="tdo-button warn" (click)="closeRef()" data-cy="ar-ledger-payment-distributions-close-btn">Close</button>
    </div>

  </div>
</div>
